// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .segment-button-checked {
  color: var(--ion-color-secondary) !important;
}
:host ion-segment {
  padding-top: constant(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-bottom);
}
:host ion-segment-button {
  color: white !important;
}
:host .dot {
  width: 12px;
  height: 12px;
  border-radius: 100%;
  border: 2px solid #fff;
  position: absolute;
  left: 30px;
  bottom: 0px;
  background-color: #4CAF50 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-side-right/custom-side-right.component.scss"],"names":[],"mappings":"AACE;EACE,4CAAA;AAAJ;AAGE;EACE,6CAAA;EACA,wCAAA;AADJ;AAIE;EACE,uBAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;AAHJ","sourcesContent":[":host {\n  .segment-button-checked {\n    color: var(--ion-color-secondary) !important;\n  }\n\n  ion-segment {\n    padding-top: constant(safe-area-inset-bottom);\n    padding-top: env(safe-area-inset-bottom);\n  }\n\n  ion-segment-button {\n    color: white !important;\n  }\n\n  .dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 100%;\n    border: 2px solid #fff;\n    position: absolute;\n    left: 30px;\n    bottom: 0px;\n    background-color: #4CAF50 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
